import React from 'react'
import classNames from 'classnames'
import './CustomStepper.css'

const CustomStepper = ({ activeSteps }) => {
	return (
		<>
			<div className='md-stepper-horizontal '>
				<div
					className={classNames('md-step box', {
						'active new': activeSteps === 0,
					})}
				>
					<div className='md-step-circle'>
						<span>1</span>
					</div>
					<div className='accontDetail'>Account Details</div>
					<div className='md-step-bar-left'></div>
					<div className='md-step-bar-right'></div>
				</div>
				<div
					className={classNames('md-step box', {
						'active new': activeSteps === 1,
					})}
				>
					<div className='md-step-circle'>
						<span>2</span>
					</div>
					<div className='accontDetail'>FFL Request</div>
					<div className='md-step-bar-left'></div>
					<div className='md-step-bar-right'></div>
				</div>
			</div>
		</>
	)
}

export default CustomStepper
